import APP_ACTIONS from '../constants/app-actions';

const initialState = {};

const wallets = (state = initialState, action) => {
    if (action.type === APP_ACTIONS.UPDATE_WALLETS) {
        return {
            ...state,
            ...action.payload,
        };
    }
    if (action.type === APP_ACTIONS.CLEAR_WALLETS) {
        return initialState;
    }
    return state;
};

export default wallets;



/** WEBPACK FOOTER **
 ** ./src/reducers/wallets.js
 **/